import {create} from 'zustand';
import {orgUnitApi} from '../services/api/orgUnitApi';

export const useOrgUnitStore = create((set) => ({
  orgUnits: [],
  isLoading: false,
  selectedOrgUnitId: null,

  setSelectedOrgUnitId: (id) => set({selectedOrgUnitId: id}),

  fetchOrgUnits: async () => {
    set({isLoading: true});
    try {
      const response = await orgUnitApi.listSimple();
      set({orgUnits: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  createOrgUnit: async (data) => {
    const response = await orgUnitApi.create(data);
    const newItem = response.data.data;
    set(state => ({orgUnits: [...state.orgUnits, newItem]}));
    return newItem;
  },

  updateOrgUnit: async (id, data) => {
    const response = await orgUnitApi.update(id, data);
    const updated = response.data.data;
    set(state => ({
      orgUnits: state.orgUnits.map(o => (o.id === id ? updated : o)),
    }));
    return updated;
  },

  deleteOrgUnit: async (id) => {
    await orgUnitApi.remove(id);
    set(state => ({
      orgUnits: state.orgUnits.filter(o => o.id !== id),
    }));
  },

  fetchOrgUnit: async (id) => {
    const response = await orgUnitApi.getById(id);
    return response.data.data;
  },

  uploadOrgUnitImages: async (id, logoFile, photoFile) => {
    const response = await orgUnitApi.uploadImages(id, logoFile, photoFile);
    const updated = response.data.data;
    set(state => ({
      orgUnits: state.orgUnits.map(o => (o.id === id ? updated : o)),
    }));
    return updated;
  },
}));
